import moment from 'moment'

export function getAgeDescription (birthday, translate) {
  const patientBirthDay = moment(new Date(birthday))
  const years = moment().diff(patientBirthDay, 'years', false)
  if (years > 1) {
    return translate('numYears', true, 'timing', {smart_count: years})
  } else {
    const months = moment().diff(patientBirthDay, 'months', false)
    if (months > 0) {
      return translate('numMonths', true, 'timing', {smart_count: months})
    } else {
      const days = moment().diff(patientBirthDay, 'days', false)
      return translate('numDays', true, 'timing', {smart_count: days})
    }
  }
}

const INSERTION_TYPE = {
  VACCINE: 'vaccine',
  PREVIOUS: 'previous',
  IMMUNOGLOBULIN: 'immunoglobulin',
  getAppropriateType: (type = '') => {
    switch (type) {
      case INSERTION_TYPE.VACCINE:
        return INSERTION_TYPE.VACCINE
      case INSERTION_TYPE.IMMUNOGLOBULIN:
        return INSERTION_TYPE.IMMUNOGLOBULIN
      case INSERTION_TYPE.PREVIOUS:
        return INSERTION_TYPE.PREVIOUS
      default:
        return null
    }
  }
}

export {INSERTION_TYPE}
